export default "__VITE_ASSET__fRDprSYD__"